import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, Col, Input, message, Radio, Row, Switch} from 'antd';
import {
    CheckOutlined,
    ClockCircleOutlined,
    CloseOutlined,
    ExportOutlined,
    FileDoneOutlined,
    FileExclamationTwoTone
} from '@ant-design/icons';
import {EXPORT_FORMAT, GLOBAL_CONFIG} from '../utils/enums'
import cookie from "react-cookies";
import {isTrue} from "../utils/utils";
import {getGlobalConfig, setGlobalConfig} from "../utils/api";


class ExportSettingsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            export_path: null,
            export_prefix: null,
            auto_export_enabled: false,
            export_format: EXPORT_FORMAT.TIFF,
            export_use_viewer_settings: true,
            tiff_levels_to_use: "",
            tiff_compression: 70,
            tiff_type: 7,
            add_metadata_to_tiff: false,
            add_standalone_viewer_to_zip: false,
        }
    }

    getData = () => {
        getGlobalConfig().then(response => {
            if (response.status !== 200) {
                message.error("Error in getting config");
            } else {
                const export_format = GLOBAL_CONFIG.EXPORT_FORMAT.key
                this.setState({
                    export_path: response.data['export_path'],
                    export_prefix: response.data['export_prefix'],
                    auto_export_enabled: isTrue(response.data['auto_export_enabled']),
                    export_use_viewer_settings: isTrue(response.data['export_use_viewer_settings']),
                    tiff_compression: (response.data['export_tiff_compression'] && parseInt(response.data['export_tiff_compression'])) || this.state.tiff_compression,
                    tiff_type: (response.data['export_tiff_type'] && parseInt(response.data['export_tiff_type'])) || this.state.tiff_type,
                    tiff_levels_to_use: response.data['export_tiff_levels'] || this.state.tiff_levels_to_use,
                    add_metadata_to_tiff: isTrue(response.data['export_add_metadata_to_tiff']),
                    add_standalone_viewer_to_zip: isTrue(response.data['export_add_standalone_viewer_to_zip']),
                    [export_format]: response.data[export_format]
                })
            }
        }).catch(err => console.log(err))
    };

    setData = (key, value) => {
        setGlobalConfig(key, value).then(res => {
            if (res.status !== 200) {
                console.error("Error in setting " + key);
            }
        }).catch(err => console.log(err))
    };

    componentDidMount = () => {
        this.getData();
    }

    changeExportPath = () => {
        this.setData("export_path", this.state.export_path);
        message.info("Export Path Updated");
    }

    changeExportPrefix = () => {
        this.setData("export_prefix", this.state.export_prefix);
        message.info("Export Prefix Updated");
    }

    changeExportFormat = (export_format) => {
        const key = GLOBAL_CONFIG.EXPORT_FORMAT.key
        this.setData(GLOBAL_CONFIG.EXPORT_FORMAT.key, export_format)
        this.setState({[key]: export_format})
        message.info("Export Format Updated")
    }

    changeUseViewerSettings = (use_viewer_settings) => {
        this.setData("export_use_viewer_settings", use_viewer_settings)
        this.setState({export_use_viewer_settings: use_viewer_settings})
        message.info("Use viewer settings Updated")
    }

    changeMetadataTiff = (add_metadata_to_tiff) => {
        this.setData("export_add_metadata_to_tiff", add_metadata_to_tiff)
        this.setState({add_metadata_to_tiff: add_metadata_to_tiff})
        message.info("Metadata Updated")
    }

    changeStandaloneViewerZip = (add_standalone_viewer_to_zip) => {
        this.setData("export_add_standalone_viewer_to_zip", add_standalone_viewer_to_zip)
        this.setState({add_standalone_viewer_to_zip: add_standalone_viewer_to_zip})
        message.info("Standalone Viewer Updated")
    }

    changeTiffCompression = () => {
        this.setData("export_tiff_compression", this.state.tiff_compression)
        message.info("Compression Updated")
    }

    changeTiffType = (tiff_type) => {
        this.setData("export_tiff_type", tiff_type)
        this.setState({tiff_type: tiff_type})
        message.info("Tiff type Updated")
    }

    changeTiffLevels = () => {
        this.setData("export_tiff_levels_to_use", this.state.tiff_levels_to_use)
        message.info("Tiff levels Updated")
    }

    onAutoExportChange = (checked, event) => {
        this.setState({
            auto_export_enabled: checked
        });
        this.setData("auto_export_enabled", checked ? "true" : "false");
        message.info(checked ? "Auto export is now ON" : "Auto Export turned off");
    }

    render() {
        return (<div id="scanner-div">
            <Row className="rounded-container">
                <Col className="scanner-name arial-font" span={24}>
                    {"Export Settings"}
                </Col>
            </Row>
            <br></br>
            <br></br>
            <Row>
                <Col span={12}>
                    {/* <Row>
                        <Col span={4} offset={1}>
                            Auto Export
                        </Col>
                        <Col span={17}>
                            <Switch
                                checkedChildren={<CheckOutlined/>}
                                unCheckedChildren={<CloseOutlined/>}
                                checked={this.state.auto_export_enabled}
                                onChange={this.onAutoExportChange}
                            />
                        </Col>

                    </Row>
                    <Row>
                        <Col span={20} offset={1}>
                            Scans taken while auto export is ON, will be auto exported to given export path.<br/>
                            If kept Off, User can always export a scan by clicking on export button from dashboard.
                        </Col>
                    </Row>
                    <br></br>
                    <Row>
                        <Col span={4} offset={1}>
                            Export Prefix
                        </Col>
                        <Col span={17}>
                            <Input.Group compact>
                                <Input style={{width: 'calc(100% - 200px)'}} value={this.state.export_prefix}
                                       onChange={(e) => e.target.value !== undefined && e.target.value !== "" ? this.setState({export_prefix: e.target.value}) : undefined}/>
                                <Button type="primary" onClick={this.changeExportPrefix}>Submit</Button>
                            </Input.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={20} offset={1}>
                            Only scans with above prefix in their name are taken up for export.<br/>
                            If left blank all the scans will be taken up for export.
                        </Col>
                    </Row>
                    <br></br> */}
                    <Row>
                        <Col span={4} offset={1}>
                            Export Path
                        </Col>
                        <Col span={17}>
                            <Input.Group compact>
                                <Input style={{width: 'calc(100% - 200px)'}} value={this.state.export_path}
                                       onChange={(e) => e.target.value !== undefined ? this.setState({export_path: e.target.value}) : undefined}/>
                                <Button type="primary" onClick={this.changeExportPath}>Submit</Button>
                            </Input.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={20} offset={1}>
                            Path Where scans are to be stored after export<br/>
                            If left blank, default path will be : Desktop/LinkToExport
                        </Col>
                    </Row>
                    <br></br>
                    <Row>
                        <Col span={4} offset={1}>
                            Export Format
                        </Col>
                        <Col span={17}>
                            <Input.Group compact>
                                <Radio.Group
                                    value={this.state.export_format}
                                    onChange={(e) => this.changeExportFormat(e.target.value)}>
                                    {Object.entries(EXPORT_FORMAT).map(([_, {ext, name}]) => (
                                        <Radio value={ext}>{name}</Radio>))}
                                </Radio.Group>
                            </Input.Group>
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col span={20} offset={1}>
                            Selecting All will export to all the available export types.<br/>
                            Please watch the disk space, as "all" will take up more disk space
                        </Col>
                    </Row> */}
                    {/* {cookie.load('superuser') === "true" ?
                        <>
                            <br/><br/>
                            <Row>
                                <Col span={8} offset={1}>
                                    Use Viewer Settings on Export (Increases export time):
                                </Col>
                                <Col span={12}>
                                    <Input.Group compact>
                                        <Radio.Group
                                            value={this.state.export_use_viewer_settings}
                                            onChange={(e) => this.changeUseViewerSettings(e.target.value)}>
                                            <Radio value={true}>Yes</Radio>
                                            <Radio value={false}>No</Radio>
                                        </Radio.Group>
                                    </Input.Group>
                                </Col>
                            </Row>
                            <br/>
                            <Row>
                                <Col span={8} offset={1}>
                                    Add Metadata to Tiff:
                                </Col>
                                <Col span={12}>
                                    <Input.Group compact>
                                        <Radio.Group
                                            value={this.state.add_metadata_to_tiff}
                                            onChange={(e) => this.changeMetadataTiff(e.target.value)}>
                                            <Radio value={true}>Yes</Radio>
                                            <Radio value={false}>No</Radio>
                                        </Radio.Group>
                                    </Input.Group>
                                </Col>
                            </Row>
                            <br/>
                            <Row>
                                <Col span={8} offset={1}>
                                    Add Standalone Viewer to zip:
                                </Col>
                                <Col span={12}>
                                    <Input.Group compact>
                                        <Radio.Group
                                            value={this.state.add_standalone_viewer_to_zip}
                                            onChange={(e) => this.changeStandaloneViewerZip(e.target.value)}>
                                            <Radio value={true}>Yes</Radio>
                                            <Radio value={false}>No</Radio>
                                        </Radio.Group>
                                    </Input.Group>
                                </Col>
                            </Row>
                            <br/>
                            <Row>
                                <Col span={6} offset={1}>
                                    Tiff Compression:
                                </Col>
                                <Col span={15}>
                                    <Input.Group compact>
                                        <Input style={{width: 'calc(100% - 200px)'}} value={this.state.tiff_compression}
                                               onChange={(e) => e.target.value !== undefined && e.target.value !== "" ? this.setState({tiff_compression: e.target.value}) : undefined}/>
                                        <Button type="primary" onClick={this.changeTiffCompression}>Submit</Button>
                                    </Input.Group>
                                </Col>
                            </Row>
                            <br/>
                            <Row>
                                <Col span={8} offset={1}>
                                    Tiff Type:
                                </Col>
                                <Col span={15}>
                                    <Input.Group compact>
                                        <Radio.Group
                                            value={this.state.tiff_type}
                                            onChange={(e) => this.changeTiffType(e.target.value)}>
                                            <Radio value={7}>JPG</Radio>
                                            <Radio value={1}>RAW</Radio>
                                        </Radio.Group>
                                    </Input.Group>
                                </Col>
                            </Row>
                            <br/>
                            <Row>
                                <Col span={6} offset={1}>
                                    Levels to use: (Format - x,y,z )
                                </Col>
                                <Col span={15}>
                                    <Input.Group compact>
                                        <Input style={{width: 'calc(100% - 200px)'}} value={this.state.tiff_levels_to_use}
                                               onChange={(e) => e.target.value !== undefined ? this.setState({tiff_levels_to_use: e.target.value}) : undefined}/>
                                        <Button type="primary" onClick={this.changeTiffLevels}>Submit</Button>
                                    </Input.Group>
                                </Col>
                            </Row>
                        </>
                        : null} */}
                </Col>
                <Col span={12}>
                    <Row>
                        <Col span={20} offset={1} style={{fontSize: '16px'}}>
                            <b>Export Guide:</b>
                            <br/><br/>
                            1. Click on the Export Button ( <ExportOutlined/> ) on the dashboard to export the scan. <br/>
                            {/* 2. The scan will be queued for export and will be exported in the background. <br/>
                            3. When queued, hover on the ( <ClockCircleOutlined style={{color: '#1890ff'}}/> ) to prioritize the export or cancel export. <br/>
                            4. Prioritized Export will be exported before other queued exports, and will be highlighted with ( <ClockCircleOutlined style={{color: '#ffc300'}}/> ). <br/>
                            5. When the scan is picked up for export, the percentage of export will be updated accordingly. <br/>
                            6. Once the scan is exported, the export icon will be updated to ( <FileDoneOutlined/> ). <br/>
                            7. The scan can be re-exported by clicking on the ( <FileDoneOutlined/> ) again. <br/>
                            8. Upon failure, the export icon will be updated to ( <FileExclamationTwoTone twoToneColor='red'/> ). <br/>
                            9. For failed export, retry exporting by clicking on the ( <FileExclamationTwoTone twoToneColor='red'/> ) again. <br/> */}
                            <br/>For further help, contact <b>Morphle Support</b> <br/>
                            <br/><br/>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>)
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

export default connect(mapStateToProps)(ExportSettingsView);
